var ACSearchQuery = /** @class */ (function () {
    function ACSearchQuery(query, filter_types) {
        this.rules = query.rules;
        this.filters = query.filters;
        this.i18n = query.i18n;
        this.filtertypes = filter_types;
    }
    ACSearchQuery.prototype.init = function () {
        this.transformFilters(this.filters);
        this.checkRules();
    };
    ACSearchQuery.prototype.checkRules = function () {
        var self = this;
        if (!this.rules) {
            return;
        }
        this.rules.rules.forEach(function (rule, index, object) {
            if (!self.getFilter(rule.id)) {
                object.splice(index, 1);
            }
        });
    };
    ACSearchQuery.prototype.hasFilters = function () {
        return this.getFilters().length !== 0;
    };
    ACSearchQuery.prototype.getFilters = function () {
        return this.filters;
    };
    ACSearchQuery.prototype.getFilter = function (id) {
        var filters = this.getFilters();
        for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            if (id === filter.id) {
                return filter;
            }
        }
        return null;
    };
    ACSearchQuery.prototype.transformFilters = function (filters) {
        var result = [];
        var self = this;
        filters.forEach(function (filter) {
            self.filtertypes.getTypes().forEach(function (type) {
                filter = type.transformFilter(filter);
            });
            result.push(filter);
        });
        return result;
    };
    ACSearchQuery.prototype.getRules = function () {
        if (!this.rules) {
            return {
                rules: [],
                condition: 'AND',
                valid: true
            };
        }
        return this.validateRules(this.rules);
    };
    ACSearchQuery.prototype.validateRules = function (rules) {
        var _this = this;
        rules.rules.forEach(function (rule, index, object) {
            if (!_this.getFilter(rule.id)) {
                object.splice(index);
            }
        });
        return rules;
    };
    ACSearchQuery.prototype.getRule = function (index) {
        var rules = this.getRules().rules;
        if (!rules) {
            return null;
        }
        if (typeof rules[index] === 'undefined') {
            return null;
        }
        return rules[index];
    };
    return ACSearchQuery;
}());
export default ACSearchQuery;
